var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "40vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.hideDuplicate()
            }
          },
          model: {
            value: _vm.show_duplicate_modal,
            callback: function($$v) {
              _vm.show_duplicate_modal = $$v
            },
            expression: "show_duplicate_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideDuplicate()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("duplicate_this_training")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "q-pa-md col-xs-12 col-sm-12" }, [
                _c("h6", { staticClass: "text-h6 q-my-md" }, [
                  _vm._v(_vm._s(_vm.$t("duplicate_this_training")))
                ]),
                _c("div", { staticClass: "text-body1 q-mb-md" }, [
                  _vm._v(_vm._s(_vm.$t("training_duplication_information")))
                ]),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "q-list",
                      {
                        staticClass: "col-12",
                        attrs: { bordered: "", separator: "" }
                      },
                      [
                        _c(
                          "q-item",
                          [
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("basic_data") }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c("q-item-main", {
                              attrs: {
                                label: _vm.$t("events_duplication_info")
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("reaction_tests") }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("support_materials") }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("inputs") }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("p", { staticClass: "q-ml-sm q-mt-md text-weight-bold" }, [
                  _vm._v(_vm._s(_vm.$t("training_duplication_save_warning")))
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "fas fa-times"
                          },
                          on: {
                            click: function($event) {
                              return _vm.hideDuplicate()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            label: _vm.$t("duplicate"),
                            icon: "far fa-copy"
                          },
                          on: { click: _vm.duplicateTraining }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }